import ListModel from '../../models/lists/ListModel.js';

const ListsCollection = Backbone.Collection.extend({

  model: ListModel,
  fetched: false,

  initialize() {
    this.pageCount = null;

    this.cachePrefix = 'ListCollection_';
  },

  sync(method, collection, options) {
    const params = _.omit($.extend(true, {}, options), ['parse', 'success', 'silent', 'reset', 'remove', 'error', 'refreshCache']);
    const cache = new Cache();
    const cacheDuration = 1;
    let data;
    const defer = $.Deferred();

    // options.reset = ( method === "read" ) ? false : true; // update takes boolean, if set true update function will be called. Update cannot be called with data
    options.reset = (options.reset === undefined ? true : options.reset);
    options.refreshCache = options.refreshCache || false;

    params.application_id = window.sendible_application_id;
    params.type = params.type || 'all';
    params.list_type = params.list_type || '';

    // process cache key
    const key = Utils.cacheManager.processCacheKey(this.cachePrefix, params);

    // if no cache then run sendible connect
    if (cache.read(key) === null || options.refreshCache) {
      Sendible.Connect.getLists('', params, (data2) => {
        options.success(data2);
        defer.resolve(data2);
        cache.store(key, JSON.stringify(data2), cacheDuration);
      }, (data1) => {
        if (options.error) options.error(data1);
        defer.reject(data1);
      });
    } else {
      data = JSON.parse(cache.read(key));

      options.success(data);
      defer.resolve(data);
    }

    const promise = defer.promise();
    return promise;
  },

  remove(models, options) {
    // run the method we are overriding first
    Backbone.Collection.prototype.remove.call(this, models, options);
  },

  updateCache(params) {
    Utils.cacheManager.updateCache(this.cachePrefix, params);
  },

  processCacheKey(params) {
    Utils.cacheManager.processCacheKey(this.cachePrefix, params);
  },

  reset(models, options) {
    for (let index = 0, { length } = this.models; index < length; index++) {
      this.models[index].trigger('remove');
    }

    Backbone.Collection.prototype.reset.call(this, models, options);
  },

});

export default ListsCollection;
